export default "__VITE_ASSET__DfLGLeP9__"